module.exports = __webpack_public_path__ + "media/images/menu/chamaeleon-dae4bb9b5628c89d667c56bf51a282ef.jpg";